<template>
  <div>
    <div class="header py-7 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <b-container class="mt--9 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" >
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center">
                <label class="form-control-label">Enter your email to unsubscribe</label>
              </div>
              <base-input alternative
                          class="mb-3"
                          prepend-icon="ni ni-email-83"
                          placeholder="Email"
                          name="Email"
                          :rules="{required: true, email: true}"
                          v-model="email">
              </base-input>
              <div class="text-center mt-4 d-flex">
                <b-button block variant="danger" @click="unsubscribe" :disabled="disabled">Unsubscribe</b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  data() {
    return {
      email: ''
    }
  },
  computed: {
    disabled() {
      return this.email.length > 0 ? false : true;
    }
  },
  methods: {
    async unsubscribe() {
      await axios.post(process.env.VUE_APP_API_BASE_URL + "/unsubscribe", {
        email: this.email
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 3000,
          icon: 'success'
        }).then(result => {
          this.$router.push("/");
        });
      })
      .catch(error => {
        swal.fire({
          title: `Error`,
          text: error.data,
          showConfirmButton: false,
          timer: 3000,
          icon: 'error'
        });
      });
    }
  }
};
</script>